// extracted by mini-css-extract-plugin
module.exports = {"dot":"ProfilePitchingSummary_dot_3Rjj9","dummy-overlay":"ProfilePitchingSummary_dummy-overlay_3JclP"};